import { toast } from "bulma-toast";

export class ToastBuilder {
    internalToast = {
        message: "",
        position: toastPositionEnum.TOP_RIGHT,
        type: toastTypeEnum.SUCCESS,
        pauseOnHover: true,
        opacity: 0.9,
        duration: 3000
    }

    constructor() { }
    
    setMessage(message) {
        this.internalToast.message = message;
        return this;
    }

    setType(type) {
        this.internalToast.type = type;
        return this;
    }

    setDuration(duration) {
        this.internalToast.duration = duration;
        return this;
    }

    toast() {
        toast(this.internalToast);
    }
}

export const toastPositionEnum = {
    TOP_RIGHT: "top-right"
}

export const toastTypeEnum = {
    SUCCESS: "is-success",
    INFO: "is-info",
    DANGER: "is-danger",
    WARNING: "is-warning"
}